module.exports = __webpack_public_path__ + "static/img/google_btn.925f0b92.png";